var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0Zm0 15.38a.961.961 0 1 1 0-1.922.961.961 0 0 1 0 1.922Zm1.044-9.67-.276 5.865a.77.77 0 0 1-1.538 0l-.276-5.862V5.71a1.045 1.045 0 1 1 2.088 0h.002Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.f682d258c9917ce56f71a826d8aab609.svg";